import ApiClient from './ApiClient'
import Axios from "axios"

export default class AuthService {

    constructor() {
        this.apiClient = new ApiClient();
     }

    signIn(username, password) {
        return Axios.post(process.env.VUE_APP_API_BASE_URL + '/auth/Login', {
            username,
            password
        });
    }

    signUp(email, password, name, acceptedTermsVersion, recaptchaToken) {
        return Axios.post(process.env.VUE_APP_API_BASE_URL + '/auth/Register', {
            email,
            password,
            name,
            acceptedTermsVersion,
            recaptchaToken
        });
    }

    forgotPassword(email) {
        return this.apiClient.create().post('/auth/forgot-password', {
            email
        });
    }

    resetPassword(userId, token, newPassword) {
        return this.apiClient.create().post('/auth/reset-password', {
            userId,
            token,
            newPassword
        });
    }

}